import type { SubSimulation } from 'types/project';

export const getRunnableSimulationCount = (subSimulations: SubSimulation[] = []) =>
  subSimulations.filter((subSim) => {
    if (subSim?.simType !== 'TARGETVIEW') {
      return true;
    }

    if (!subSim?.params?.enabled) {
      return false;
    }

    return Array.isArray(subSim?.params?.targets) && subSim.params.targets.length > 0;
  }).length;

export const getSimulationLimitMessage = (remainingCount: number | null, requiredCount: number) => {
  if (remainingCount === null) {
    return '';
  }

  if (remainingCount <= 0) {
    return 'No simulations are available on this project.';
  }

  if (requiredCount > remainingCount) {
    return `This simulation set requires ${requiredCount} ${requiredCount === 1 ? 'simulation' : 'simulations'}, but only ${remainingCount} ${
      remainingCount === 1 ? 'is' : 'are'
    } available on this project.`;
  }

  return '';
};
